
    export default {
        props: {
            fixed: { default: false, type: Boolean },
            optional: { default: false, type: Boolean },
            displayName: { required: true, type: String },
            value: { required: true },
        },
        data () {
            return {
                isVisible: !this.optional,
                name: this.label,
            };
        },
        methods: {
            applyFilter() {
                this.$emit('apply-filter');
            },
            // Override this method in extending components
            afterValueChanged(newValue, oldValue) {},
        },
        watch: {
            isVisible(newValue) {
                this.$emit('visibility-changed', newValue);
            },
            value: {
                handler(newValue, oldValue) {
                    this.$emit('value-changed', newValue);
                    this.afterValueChanged(newValue, oldValue);
                },
                deep: true,
            },
        },
    };
